import React, { useState } from "react";
import "./ContactSec3.css";
import { Image, Stack } from "react-bootstrap";
import { chunk, map } from "lodash";
import { FaLocationDot } from "react-icons/fa6";
import { MdLocalPhone } from "react-icons/md";
import { IoMail } from "react-icons/io5";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

export const ContactSec3 = () => {
    const [selected, setSelected] = useState()
    const locations = [
        { id: 1, img: "/assets/india1.png", name: "India", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "Plot No. 12-A, beside JVJ Sky Line, Sanganer, Gram, Ramnagariya, Jaipur, Rajasthan 302017" },
        { id: 2, img: "/assets/location2.png", name: "UAE", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "1210-1211, Regal Tower, Business Bay, Dubai UAE" },
        { id: 3, img: "/assets/location3.png", name: "Kenya", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "Showroom No.3, Groun Floor, Western Heights,Karuna Road, Westlands.Nairobi, Kenya" },
        { id: 4, img: "/assets/location4.png", name: "Tanzania", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "S-24 B, Ground Floor, Haidery Plaza.Dar es Salam, Tanzania" },
        // { id: 5, img: "/assets/location5.png", name: "South Africa", contact: "+91 90017 99381", email: "holidays@blueberrydmc.com", address: "1210-1211, Regal Tower, Business Bay, Dubai UAE" },
        { id: 6, img: "/assets/location6.png", name: "Zimbabwe", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "179, King George Road, Avondale.Harare, Zimbabwe" },
        { id: 7, img: "/assets/location7.png", name: "Uganda", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "Plot 08, Nita Building, Colville Street, P.O Box 36923Kampala, Uganda" },
        { id: 8, img: "/assets/location8.png", name: "Zambia", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "12 & 13 D&D Centre, Makishi Road x Great East Road.Lusaka, Zambia" },
        { id: 9, img: "/assets/location9.png", name: "Qatar", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "Shop No. 6, Doha Souq Mall Ground Floor Al Nassr Street, Doha, Qatar" },
        { id: 10, img: "/assets/location10.png", name: "Malaysia", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "1210-1211, Regal Tower, Business Bay, Dubai UAE" },
        { id: 11, img: "/assets/location11.png", name: "Singapore", contact: "+971 559 886749", email: "holidays@Blueberrydmc.com", address: "1210-1211, Regal Tower, Business Bay, Dubai UAE" },
    ]

    return (
        <div className="contactsec3 standard-padding">
            <h5 className="heading mb-4" style={{ textAlign: "center" }}>Discover 10 Iconic Travel Locations For You</h5>

            <Stack className="contactsec3-content">
                {map(locations, (d, index) => (
                    <Locations
                        key={index}
                        data={d}
                        selected={selected}
                        setSelected={setSelected}
                    />
                ))}
            </Stack>
        </div>
    )
}

const Locations = ({ data, selected, setSelected }) => {
    const handleSelect = () => {
        if (selected === data.id) {
            setSelected()
        }
        else {
            setSelected(data.id)
        }
    }
    return (
        <Stack className={`contactsec3-card ${selected === data.id ? "contactsec3-card-selected" : ""}`}>
            <Stack direction="horizontal" className="contactsec3-card-heading" onClick={handleSelect}>
                <div>
                    <Image src={data.img} className="contactsec3-card-image" alt="image" />
                    <h6 className="contactsec3-card-title">{data.name}</h6>
                </div>
                {selected === data.id ? <img src="/assets/contact-up-arrow.svg" style={{ width: "18px", height: "auto", cursor: "pointer" }} /> : <img src="/assets/contact-down-arrow.svg" style={{ width: "18px", height: "auto", cursor: "pointer" }} />}
            </Stack>
            {selected === data.id ?
                <Stack gap={3} className="contactsec3-card-data">
                    <div className="contactsec3-card-data-div2">
                        <div className="contactsec3-card-data-div"><img src="/assets/contact-location-icon.svg" style={{ width: "18px", height: "auto", marginTop: "2px" }} /> <p>{data.address}</p></div>
                        {/* <img src="/assets/contact-share.svg" style={{ width: "18px", height: "auto", marginTop: "2px" }} /> */}
                    </div>
                    <div className="contactsec3-card-data-div"><img src="/assets/contact-phone-icon.svg" style={{ width: "18px", height: "auto", marginTop: "2px" }} /> <p>{data.contact}</p></div>
                    <div className="contactsec3-card-data-div"><img src="/assets/contact-mail-icon.svg" style={{ width: "18px", height: "auto", marginTop: "2px" }} /> <p>{data.email}</p></div>
                </Stack>
                :
                null
            }
        </Stack>
    )
}